"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactIntl = require("react-intl");

var _actions = require("../reducers/auth/actions");

var _actions2 = require("../reducers/app/actions");

var _connectRouter = require("../../decorators/connectRouter");

var _connectRouter2 = _interopRequireDefault(_connectRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./Appbar.less");

var LOGOUT_EVENT_KEY = "LOGOUT";
var SIDEBAR_EVENT_KEY = "SIDEBAR";
var imgSparLogo = require("../../assets/img/logo.png");
function shouldShowAllReportBacklink(props) {
    return props.location.pathname.indexOf("/reports/detail/") >= 0;
}
var Appbar = function (_React$Component) {
    _inherits(Appbar, _React$Component);

    function Appbar() {
        var _Object$getPrototypeO;

        _classCallCheck(this, Appbar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Appbar)).call.apply(_Object$getPrototypeO, [this].concat(args)));

        _this.handleNavSelect = function (eventKey) {
            switch (eventKey) {
                case LOGOUT_EVENT_KEY:
                    _this.props.dispatch((0, _actions.logout)());
                    break;
                case SIDEBAR_EVENT_KEY:
                    _this.props.dispatch((0, _actions2.toggleSidebar)());
                    break;
                default:
                    console.error("Appbar handleNavSelect: Unexpected eventKey", eventKey);
            }
        };
        return _this;
    }

    _createClass(Appbar, [{
        key: "render",
        value: function render() {
            var _props = this.props;
            var router = _props.router;
            var username = _props.username;
            var guildId = _props.guildId;

            var logoutButton = null;
            var signInInfo = null;
            var toggleSidebarButton = null; // only active if in route dashboard!
            var sendEmailToSupport = null;
            var backlink = "/";
            var guildLogo = null;
            var guildLogoSrc = __API_BASE_URL__ + "/assets/guilds/" + guildId + "/logo.png";
            // attention, occurence matching must be done from highest to lowest!
            if (shouldShowAllReportBacklink(this.props)) {
                backlink = "/reports";
            }
            var address = "Onlinebefund@kfe.at";
            var subject = "Frage zum digitalen E-Befund";
            var body = "Sehr geehrte Damen und Herren!";
            if (router.isActive("/login") === false) {
                logoutButton = React.createElement(_reactBootstrap.NavItem, { eventKey: LOGOUT_EVENT_KEY }, React.createElement(_reactIntl.FormattedMessage, { id: "logout" }));
                sendEmailToSupport = React.createElement("p", { className: "navbar-text hidden-xs" }, React.createElement("a", { href: "mailto:" + address + "?subject=" + subject.replace(" ", "%20") + "&body=" + body.replace(" ", "%20") }, React.createElement(_reactIntl.FormattedMessage, { id: "sendEmailToSupport" })));
                signInInfo = React.createElement("p", { className: "Appbar-username navbar-text hidden-xs" }, React.createElement(_reactIntl.FormattedMessage, { id: "loggedInAs", values: {
                        user: username
                    } }));
                guildLogo = React.createElement("img", { src: guildLogoSrc, style: { height: "50px" } });
            }
            if (router.isActive("/") === true) {
                toggleSidebarButton = React.createElement(_reactBootstrap.NavItem, { className: "hidden-xs", eventKey: SIDEBAR_EVENT_KEY }, React.createElement("i", { className: "fa fa-bars" }));
            }
            return React.createElement("div", { styleName: "Appbar" }, React.createElement(_reactBootstrap.Navbar, { fluid: true, fixedTop: true }, React.createElement(_reactBootstrap.NavbarBrand, null, React.createElement(_reactRouter.Link, { styleName: "Appbar-brand", to: "/" }, React.createElement("aside", null, React.createElement("i", { style: { left: 10, position: "absolute", display: backlink === "/" ? "none" : "inherit" }, className: "fa fa-angle-left fa-2x" }), React.createElement("img", { src: imgSparLogo }), React.createElement(_reactIntl.FormattedMessage, { id: "title" })))), React.createElement(_reactBootstrap.Navbar.Collapse, null, React.createElement(_reactBootstrap.Nav, { navbar: true, onSelect: this.handleNavSelect }, toggleSidebarButton), React.createElement(_reactBootstrap.Nav, { navbar: true, pullRight: true }, guildLogo), React.createElement(_reactBootstrap.Nav, { navbar: true, pullRight: true, onSelect: this.handleNavSelect }, signInInfo, logoutButton), React.createElement(_reactBootstrap.Nav, { navbar: true, pullRight: true }, sendEmailToSupport))));
        }
    }]);

    return Appbar;
}(React.Component);
Appbar.propTypes = {
    router: React.PropTypes.object.isRequired,
    username: React.PropTypes.string,
    dispatch: React.PropTypes.func.isRequired,
    guildId: React.PropTypes.number
};
Appbar = __decorate([_connectRouter2.default, (0, _reactRedux.connect)(function (state, ownProps) {
    return {
        username: state.auth.username,
        router: ownProps.router,
        guildId: state.auth.guildId
    };
}), (0, _reactCssModules2.default)(styles)], Appbar);
exports.default = Appbar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/Appbar.tsx
 ** module id = 1268
 ** module chunks = 0
 **/